import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
        <p>Privacy Policy for MyLittleDictionary

           Effective Date: 25.07.2024</p>

<p>1. <span style={{fontWeight: 'bold'}}>Introduction</span><br></br>
This Privacy Policy outlines how MyLittleDictionary collects, uses, and protects your personal data when you use our web application. By using our service, you consent to the data practices described in this policy.</p>

<p>2. <span style={{fontWeight: 'bold'}}>Information We Collect</span><br></br>
When you log in using Google, we may collect the following information:

<ul>
{/* <li>Name</li>
<li>Email address</li>
<li>Profile picture</li> */}
<li>User ID: We store this ID in an encrypted or hashed format to enhance security.</li>
</ul>
</p>

<p>
    3. <span style={{fontWeight: 'bold'}}>Purpose of Data Collection</span><br></br>
We use your personal data for the following purposes:

<ul>
<li>To authenticate your identity when you log in.</li>
<li>To save and retrieve your translations.</li>
<li>To improve our services.</li>
</ul>
</p>

<p>
4. <span style={{fontWeight: 'bold'}}>Data Storage and Security</span><br></br>
We take reasonable measures to protect your personal data from unauthorized access, loss, or misuse. Your User ID is stored in an encrypted or hashed format in our database to enhance security.
</p>

<p>
5. <span style={{fontWeight: 'bold'}}>User Rights</span><br></br>
You have the following rights regarding your personal data:

<ul>
<li>Access: You can request a copy of your personal data.</li>
<li>Rectification: You can request correction of any inaccuracies in your data.</li>
<li>Erasure: You can request deletion of your data at any time.</li>
<li>Withdrawal of Consent: You can withdraw your consent at any time by contacting us.</li>
</ul>
</p>

<p>
6. <span style={{fontWeight: 'bold'}}>Changes to This Privacy Policy</span><br></br>
We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website.
</p>

<p>
7. <span style={{fontWeight: 'bold'}}>Contact Us</span><br></br>
If you have any questions or requests regarding your personal data, please contact us at: tinabhawal5@gmail.com
</p>

    </div>
  )
}

export default PrivacyPolicy